export const OPERATORS = {
    NO_OP: 'NO_OP',
};

export const UPGRADE_PLAN_PAGE_LINKS = {
    UPGRADE_PAGE: 'change-plan',
    PAYMENT_SELECTION: 'change-plan-payment-selection',
    TIER_SELECTION: 'change-plan-tier-selection',
    BUNDLE_SAVE_ADDON_SELECTION: 'bundle-save-change-plan-addon',
    ADDON_SELECTION: 'change-plan-addon-selection',
    PLAN_DETAILS: 'change-plan-summary-detail',
    PAYMENT_PIN_VERIFICATION: 'change-plan-pin-verification',
    LEGACY_TIER_UPGRADE: 'legacy-tier-change-plan-pin-verification',
    QUERY_PARAMS: {
        UPGRADE_SUCCESS: 'change-plan-success',
        UPGRADE_PAYMENT_MAETHOD: 'change-plan-payment-method',
    },
};

export const UPGRADE_ACTION_TYPE = {
    UPGRADE: 'upgrade',
    RESUBSCRIBE: 'resubscribe',
    CHANGE_PLAN: 'changePlan',
    ADDON: 'addon',
    MANAGE_ADDON: 'manageAddons',
};

export const ADDON_STEPS_TYPE = {
    ADDON_STEP: 'addon',
    BUNDLE_AND_SAVE_ADDON_STEP: 'bundleAndSave',
};

export const LAGACY_TIER_GUIDS = {
    LITE_TIER: 'LITE_TIER',
    ClASSIC_TIER: 'CLASSIC_TIER',
    PREMIUM_TIER: 'PREMIUM_TIER',
};

export const PAYMENT_TYPES = {
    DCB: 'DCB',
    CARD: 'CC',
    GIFT_CARD: 'GC',
};

export const TIER_TYPES = {
    FREE_TIER: 'free',
    PAID_TIER: 'paid',
    BASIC_TIER: 'basic',
};

export const PLAN_TYPES = {
    BASIC_PLAN: 'Basic',
    PREMIUM: 'Premium',
};

export const SUBSCRIPTION_PAGE_HASH_LINKS = {
    PAYMENT_SELECTION: 'payments',
    ADDON_SELECTION: 'addon-list',
    BUNDLE_ADDON_SELECTION: 'bundle-addon-list',
    SUMMARY: 'summary',
    USER_INFO: 'userinfo',
    PIN_VERIFICATION: 'verification',
    SUCCESS: 'success',
    PAYMENT_CONFIRMATION: 'payment-confirmation',
    BUNDLE_USER_THANKYOU: 'thankyou',
};

export const PACKAGE_TYPE = {
    ADD_ON: 'ADD_ON',
    ADD_ON_FREE: 'ADD_ON_FREE',
    ALACARTE: 'ALACARTE',
    ALACARTE_FREE: 'ALACARTE_FREE',
};

export const ADDON_STATUS = {
    STATUS_ACTIVE: 'ACTIVE',
    STATUS_UNSUBSCRIBED: 'UNSUBSCRIBED',
    STATUS_CANCELLED: 'CANCELLED',
    STATUS_SUSPENDED: 'SUSPENDED',
    STATUS_TERMINATED: 'TERMINATED',
    STATUS_UNKNOWN: 'UNKNOWN',
    STATUS_ENROLLED: 'ENROLLED',
};

export const B2C_ACCOUNT_PAGE_LINKS = {
    ACCOUNT_PAGE: 'purchase-addon',
    PAYMENT_SLECTION: 'purchase-addon-payment-selection',
    PURCHASE_ADDON: 'purchase-addon-selection',
    BUNDLE_SAVE_PURCHASE_ADDON: 'bundle-save-purchase-addon',
    PLAN_DETAILS: 'purchase-addon-plan-detail',
    ORDER_DETAIL: 'purchase-addon-order-detail',
    PIN_VERIFICATION: 'purchase-addon-pin-verification',
    QUERY_PARAMS: {
        RESUBSCRIBED_ADDON_SUCCESS: 'resubscribe-cc',
        RESUBSCRIBED_ADDON_PAYMENT_MAETHOD: 'resubscribe-payment-method',
    },
    MANAGE_ADDON: 'manage-addons',
    MANAGE_ADDON_PIN_VERIFICATION: 'manage-addons-pin-verification',
    DELETE_USER_ACCOUNT: 'delete-user-account',
    LEGACY_TIERS_INFO: 'legacy-tiers-info',
};

export const B2B_ACCOUNT_PAGE_LINKS = {
    PAID_ADDON_LINK: 'pick-addons-paid',
    SWAP_FREE_ADDON_LINK: 'pick-addons-free',
    FREE_ADDON_LINK: 'pick-addons-free?show=available',
    SWAP_TO_FREE_QUOTA_CONSUMED_LINK: 'pick-addons-free?swap=',
    SWAP_TO_FREE_QUOTA_AVAILABLE_LINK: 'pick-addons-free?show=available&swap=',
    MANAGE_ADDON_LINK: 'addons',
    ORDER_SUMMARY_LINK: 'pick-order-details',
};
export const PAYMENT_SWITCH_HASH_LINKS = {
    PAYMENT_METHOD_SELECTION: 'payment-switch-selection',
    QUERY_PARAMS: {
        PAYMENT_SWITCH_SUCCESS: 'success',
        PAYMENT_SWITCH_METHOD: 'payment-switch-method',
        PAYMENT_SWITCH_NUMBER: 'payment-switch-number',
    },
};

export const addonListPriority = {
    NETFLIX: 1,
    AMAZON: 2,
    SHAHID: 3,
};

export const ADDON_PURCHASE_TYPES = {
    CROSS_GRADE: 'CROSS_GRADE',
    BUY_THROUGH: 'BUY_THROUGH',
};

export const THIRD_PARTY_PARTNER_NAMES = {
    NETFLIX: 'NETFLIX',
    AMAZON: 'AMAZON',
    SHAHID: 'SHAHID',
    DISNEY: 'DISNEY_PLUS',
};

export const THIRD_PARTY_ADDONS_STATUS = {
    ACTIVATED: 'ACTIVATED',
    ENROLLED: 'ENROLLED',
    SUBSCRIBED: 'SUBSCRIBED',
    CREATE: 'CREATE',
};

export const CART_ADDITIONAL_DISCOUNT_TYPES = {
    DEFAULT: {
        ID: 'DEFAULT',
        LABEL: 'additional_discount', // this key is coming from cms
    },
    // PROMO_CODE: {
    //     ID: 'PROMO_CODE',
    //     LABEL: 'promocode_discount',
    // },
    QITAF: {
        ID: 'QITAF',
        LABEL: 'qitaf_discount',
    },
    BUNDLE_AND_SAVE: {
        ID: 'BUNDLE_AND_SAVE',
        LABEL: 'addons_discount',
    },
};

export const LEGACY_UPGRADE_STEP = {
    LANDING: 'landing',
    PASSWORD: 'password',
};

export const BILLING_CYCLE_MAPPING = {
    weekly: 1,
    monthly: 0,
};

// This config has been moved, should be removed after testing...
export const GAMIFICATION_REDEEM_REWARD_TYPE = {
    TVOD: 'tvod',
    UPGRADE: 'upgrade',
};
